import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

const Popup = (props) => {
	const [dropUp, setDropUp] = useState(true)

	useEffect(
		() => {
      let timer1, timer2, timer3;
      let time = localStorage.getItem('infopopup_timestamp');
      if(!time || (new Date().getTime() - parseInt(time)) > 86400000 ){
        timer1 = setTimeout(() => setDropUp(true), 10000)
        timer2 = setTimeout(() => setDropUp(false), 1000)
        timer3 = setTimeout(() => props.after(), 11000)
        localStorage.setItem('infopopup_timestamp', new Date().getTime());
      }
			return () => {
        if(timer1)
				  clearTimeout(timer1)
				if(timer2)
          clearTimeout(timer2)
				if(timer3)
          clearTimeout(timer3)
			}
		},
		[]
	)

  const popupClasses = classNames(
    'powerful-editor__popup',
    { 'dropup':  dropUp },
  );

  return (
    <div className={popupClasses}>
      <div className="powerful-editor__popup--header">
        <a onClick={() => { setDropUp(true); props.after() }} className="powerful-editor__popup--close">
          <i className="fa fa-remove" />
        </a>
      </div>
      <div className="powerful-editor__popup--content">
        {props.children}
      </div>
    </div>
  );
}
export default Popup;
